"use client";

import { Modal } from '@components/atoms/Modal';
import Button from '@components/atoms/Button';
import Image from 'next/image';
import styles from './RequestCallBackModal.module.scss';
import assetLoader from '@utils/internalImageLoder';

interface RequestCallBackModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const RequestCallBackModal = ({ isOpen, onClose }: RequestCallBackModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className={styles.requestCallBackModal}
      headerClassName={styles.hideHeader}
      overlayClassName={styles.requestCallBackModalOverlay}
    >
      <div className={styles.modalContent}>
        {/* Icon Section */}
        <div className={styles.iconSection}>
          <Image
            src={`${assetLoader()}/icons/intent-modal/call-back-icon.svg`}
            alt="Call-back"
            width={32}
            height={32}
            className={styles.callBackIcon}
          />
        </div>

        {/* Text Section */}
        <div className={styles.textSection}>
          <h2 className={styles.title}>Thanks!</h2>
          <p className={styles.subtitle}>
            While you stay online, one of our experts will assist you shortly
          </p>
        </div>

        {/* OK Button */}
        <Button className={styles.okButton} onClick={onClose}>
          OK
        </Button>
      </div>
    </Modal>
  );
};

export default RequestCallBackModal; 